import Error from "./Error";
import log from "loglevel";
import React, { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // #337: a render-time throw anywhere under this boundary is caught here so the
  // app shows the Error fallback instead of a blank white screen. Log the error
  // and component stack so it is visible in the console / loglevel sink.
  componentDidCatch(error, errorInfo) {
    log.error("[ErrorBoundary] caught render error:", error, errorInfo);
  }

  // #337: default fallback action is a full reload (recover from a corrupt
  // client state); callers may pass their own tryAgain.
  reload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Error
          title={this.props.title ? this.props.title : "Error Loading"}
          tryAgain={this.props.tryAgain ? this.props.tryAgain : this.reload}
        />
      );
    }

    return this.props.children;
  }
}
